import { useAtomValue, useSetAtom } from "jotai";
import { Cylinder } from "lucide-react";
import { useEffect } from "react";
import { useLocation } from "wouter";
import { FAB } from "@/components/ui/FAB";
import { appShell, tanksAtom } from "@/store";
import { TankCard } from "./components/TankCard";

export function TanksPage() {
  const setBackButton = useSetAtom(appShell.backButtonAtom);
  useEffect(() => {
    setBackButton(false);
  }, [setBackButton]);

  const [, setLocation] = useLocation();
  const tanks = useAtomValue(tanksAtom);

  const handleCreateTank = () => {
    setLocation("/app/tanks/new");
  };

  const handleTankClick = (tankId: string) => {
    setLocation(`/app/tanks/${tankId}`);
  };

  return (
    <div className="p-4 pb-20 bg-gray-50">
      <h1 className="text-2xl font-bold text-gray-900 mb-6">Tanques</h1>

      {tanks.length === 0 ? (
        <div className="bg-white rounded-xl border border-gray-200 p-8 text-center">
          <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <Cylinder className="w-8 h-8 text-gray-400" />
          </div>
          <h3 className="text-lg font-medium text-gray-900 mb-2">Nenhum tanque encontrado</h3>
          <p className="text-gray-600">
            Crie seu primeiro tanque para começar a gerenciar a fertirrigação da propriedade.
          </p>
        </div>
      ) : (
        <div className="grid gap-4 grid-cols-1 sm:grid-cols-2 lg:grid-cols-3">
          {tanks.map((tank) => (
            <TankCard key={tank.id} tankId={tank.id} onClick={() => handleTankClick(tank.id)} />
          ))}
        </div>
      )}

      <FAB onClick={handleCreateTank} className="right-4 bottom-20" />
    </div>
  );
}
